export const GET_COMMENTS_QUERY = `
    fragment CommentFields on Comment {
        id
        databaseId
        content
        date
        rate
        likes
        dislikes
        author {
            node {
                name
            }
        }
        commentedOn {
            node {
              databaseId
            }
        }
        parent {
            node {
              databaseId
            }
        }
        authorRoles
    }
  
    query GetComments($postId: [ID], $first: Int, $after: String) {
      comments(where: {contentIdIn: $postId, parent: 0}, first: $first, after: $after) {
        nodes {
          ...CommentFields
          replies {
            nodes {
              ...CommentFields
              replies {
                nodes {
                  ...CommentFields
                  replies {
                    nodes {
                      ...CommentFields
                      replies {
                        nodes {
                          ...CommentFields
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
`;
